module.exports = __webpack_public_path__ + "img/map.be562680.png";